import {SchedulePolicy, useInterval} from "@khanacademy/wonder-blocks-timing";
import {GuideStateApi} from "@repo/guide-state";
import {useUserAttributes} from "@repo/shared-core";

import {useFetchCooldownStatus} from "../queries/use-fetch-cooldown-status.ts";

/**
 * Polls the server for the Khanmigo cooldown status for the current user and
 * syncs it with the GuideState as necessary.
 */
export const usePollCooldownStatus = () => {
    const userAttributes = useUserAttributes();
    const skip = !userAttributes?.isAIGuideEnabled;
    const cooldownStatusResponse = useFetchCooldownStatus({skip});

    useInterval(
        () => {
            if (cooldownStatusResponse.status === "success") {
                const currentState = cooldownStatusResponse.hasCooldown;
                GuideStateApi.set("isOffline", currentState);
                GuideStateApi.set(
                    "cooldownStatus",
                    cooldownStatusResponse.cooldownStatus,
                );
            }
            cooldownStatusResponse.refetch();
        },
        // We poll every 15 seconds. We used to poll every 5 seconds, but when
        // doing a cost analysis we determined 5 second polling was costing
        // us ~$70k/year. This cuts the cost to ~$20k year (though note that
        // there other potential savings to be had).
        //
        // See:
        // https://khanacademy.slack.com/archives/C5Y6NG23A/p1741812643043019
        15000,
        {
            schedulePolicy: skip
                ? SchedulePolicy.OnDemand
                : SchedulePolicy.Immediately,
        },
    );

    return cooldownStatusResponse;
};
